export default __webpack_public_path__ + "static/media/img11.21c1a993.PNG";